
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'

const initialFormData = {
  firstName: '',
  lastName: '',
  companyName: '',
  email: '',
  phone: '',
  market: '',
  text: '',
}

export default {
  name: 'ContactForm',

  mixins: [validationMixin],

  data() {
    return {
      formData: {
        ...initialFormData,
      },
      captchaVerified: false,
      isLoading: false,
      isSubmitted: false,
      isSubmitEnabled: false,
    }
  },

  mounted() {
    setTimeout(() => {
      this.isSubmitEnabled = true
    }, 10000)
  },

  validations: {
    formData: {
      firstName: { required },
      email: { required, email },
      phone: { required },
      market: { required },
    },
  },

  methods: {
    async onSubmit(e) {
      if (!this.isSubmitEnabled) return

      this.$v.$touch()
      if (this.$v.$invalid) return
      // if (!this.captchaVerified) return
      this.isLoading = true

      try {
        await this.$axios.$post(
          'https://api.ltng.app/v2/modules/marketing-cms/form-submit',
          {
            account_id: '3179c16d-4098-45a1-8a9b-12f088afe0cd',
            data: {
              ...this.formData,
            },
          }
        )

        this.isSubmitted = true
        this.$toasted.success("Thanks! We'll be in touch soon!")
        this.onReset()
      } catch (error) {
        console.log(error)
        // this.$bugsnag.notify(error)
      }

      this.isLoading = false
    },

    onReset() {
      this.formData = {
        ...initialFormData,
      }
    },

    onCaptchaVerify(e) {
      this.captchaVerified = true
    },
  },
}
